import { useMe } from './auth';
import React, { createContext, useMemo } from 'react';

const OrganizationContext = createContext<{
  organizationId?: string;
  setOrganizationId: (organizationId: string | undefined) => void;
}>({
  setOrganizationId: () => {},
});

export const OrganizationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { data: account } = useMe(true);
  const organizationId = account?.organizations?.length
    ? account.organizations[0].organizationId
    : undefined;

  const [organizationIdState, setOrganizationIdState] = React.useState<
    string | undefined
  >(organizationId);

  const context = useMemo(() => {
    return {
      organizationId: organizationIdState || organizationId,
      setOrganizationId: setOrganizationIdState,
    };
  }, [organizationIdState, organizationId, setOrganizationIdState]);

  return (
    <OrganizationContext.Provider value={context}>
      {children}
    </OrganizationContext.Provider>
  );
};

export const useCurrentOrganizationId = (deprecated?: boolean) => {
  const { organizationId } = React.useContext(OrganizationContext);
  return organizationId;
};

export const useSetCurrentOrganizationId = () => {
  const { setOrganizationId } = React.useContext(OrganizationContext);
  return setOrganizationId;
};
